import React, { useEffect, useState } from 'react'
import '../styling/containerStyles.css';
import { getBase64 } from './Functions/imageCompress';
import ButtonComp from '../components/button'
import Button from '@material-ui/core/Button';
import { Grid } from "@material-ui/core";
import DialogCamera from './dialogCamera';
import profilePic from '../assets/images/avatar3.png'
import Label from '../components/label'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import './style.css';
const axios = require('axios').default;

interface ImageUploadPageProps {
    setIsOnfidoPage: any;
    membershipID: any;
    faceCompare: Function;
    getSelfieFile: Function;
    faceLiveMessage?: any;

}
let imageChange = false;

export const ImageUploadPage: React.FC<ImageUploadPageProps> = (props: ImageUploadPageProps) => {

    const {
        setIsOnfidoPage, membershipID, faceCompare, getSelfieFile, faceLiveMessage
    } = props;

    const [uploadImage, setUploadImage] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [imagesData, setImagesData] = useState([]);
    const [contractorImage, setContractorImage] = useState([]);
    const [getImageUrl, setGetImageUrl] = useState("");

    useEffect(() => {
        // getSelfieFile()
    }, [])

    const dialogOpen = async (props: any, data: any) => {
        imageChange = true;
        setUploadImage(!uploadImage)
        if (data && data.base64) {
            console.log(data.base64)
            const hello = await getBase64(data.base64) as string;
            console.log(hello, "hello")
            setContractorImage(data)
            setImageUrl(hello)
            setImagesData(data)
            getSelfieFile(await getBase64(data.base64))
        }
    };

    const handleSubmitImage = async () => {
        await faceCompare();
    }

    return (
        <div className='doc-upload-main'>
            
            <div className='buttonAndLabel'>
                <Button className='goBack' ><ArrowBackIosIcon /></Button>
                <Label content='Online KYC Verification' />
            </div>
            <Grid item xs={12} style={{ textAlign: "center" }}>
                <img style={{ width: 130, height: 130, borderRadius: "50%" }}
                    src={imageUrl && imageUrl ? imageUrl : profilePic}
                    alt="KYC Profile" />
                <div className="selfie_btn_paytm2 button">
                    <Button
                        // disabled={this.props.status.isDisabled || values.kycIdProofValidation === 'KYC Uploaded'}
                        onClick={async (e) => {
                            (setUploadImage(true))
                        }}>Upload selfie</Button></div>
                {/* <div className="selfie_btn_paytm2 button">
                    <button onClick={async (e) => {
                        (setUploadImage(true))
                    }}>
                        Upload selfie</button>
                </div> */}

                <input
                    type="file"
                    accept="image/png, image/jpeg"
                    name="contractorImage"
                    // disabled={this.props.status.isDisabled || values.kycIdProofValidation === 'KYC Uploaded'}
                    style={{ visibility: "hidden" }}
                    onChange={async (e) => {

                    }}
                >
                </input>
                {
                    <p style={{ color: "red", margin: '8px 0px 0px', display: 'flex', justifyContent: "center" }}>
                        {faceLiveMessage}
                    </p>
                }
            </Grid>
            <DialogCamera
                cameraProps={props}
                openDialog={uploadImage}
                updatestate={dialogOpen}
                openWebcam={true}
            />
            <ButtonComp label={'PROCEED'}
                name={'PROCEED'}
                visible={true}
                disabled={!imageUrl}
                handleToUpdate={handleSubmitImage}
            />

        </div>
    )
}


export default ImageUploadPage




